// const { format } = require('date-fns')
const { default: slugify } = require('slugify')
// Replacing '/' would result in empty string which is invalid
export const replacePath = (path: string) => (path === `/` ? path : path.replace(/\/$/, ``))

export function transformSidebarsToStructuredObject(fetchedSidebars) {
    const structuredSidebars = {}

    fetchedSidebars.forEach((sidebar) => {
        // Use the sidebar name as the key and its items as the value
        structuredSidebars[sidebar.name] = sidebar.items
    })

    return structuredSidebars
}

export function replacePath2(slug: string, publishedAt: string | undefined, lang: string, base: string) {
    let publishedAtDate: Date
    let dateSegment = ''
    if (publishedAt) {
        if (publishedAt instanceof Date) {
            publishedAtDate = publishedAt
        } else {
            publishedAtDate = new Date(publishedAt)
        }
        dateSegment = '/' + publishedAtDate.getFullYear() + '/' + ('0' + (publishedAtDate.getMonth() + 1)).slice(-2)
    }

    const langSegment = lang && lang != 'en' ? `/${lang}` : ''
    const path = `${base}${langSegment}${dateSegment}/${slugify(slug.toLowerCase(), {
        lower: true,
    })}`
    return path
}

export function debugChainFunction(val) {
    console.log(val)
    return val
}

export function isFuture<DateType extends Date>(dirtyDate: DateType | number): boolean {
    const today = new Date()

    let blogDate: Date
    if (dirtyDate instanceof Date) {
        blogDate = dirtyDate
    } else {
        blogDate = new Date(dirtyDate)
    }

    return blogDate.getTime() > today.getTime()
}

export function flattenMenu(items, breadcrumb = []) {
    // Check if 'items' is an array and not empty, otherwise return an empty array
    if (!Array.isArray(items) || items.length === 0) {
        return []
    }

    return items.reduce((acc, item) => {
        if (item.url) {
            acc.push({
                url: item.url,
                name: item.name,
                breadcrumb: [...breadcrumb, { url: item.url, name: item.name }],
            })
        }
        if (item.children) {
            acc.push(
                ...flattenMenu(item.children, [
                    ...breadcrumb,
                    { name: item.name, url: item.url || (item.children[0] && item.children[0].url) },
                ])
            )
        }
        return acc
    }, [])
}
